@if (isLoadingLabelVisible) {
  <div id="loaderModal" class="modal">
    <div class="modal-content">
      <p>Please wait, while table is loaded.</p>
    </div>
  </div>
}

<div class="container my-0 mx-1 position-relative">
  <table class="position-relative table table-bordered m-0">
    <tbody cdkDropList (cdkDropListDropped)="fieldDropped($event)" [cdkDropListDisabled]="isReadOnly">
      @for (row of table; track row; let rowIndex = $index) {
        <tr class="position-relative" cdkDrag>
          <div class="drag-handle" cdkDragHandle>
            <i class="bi bi-grip-vertical" (contextmenu)="onRightClick($event, rowIndex, 0)"></i>
          </div>
          <ng-template cdkDragPreview>
            <div class="custom-drag-preview">
              <div class="row">
                @for (cell of row.columns; track cell) {
                  <div class="col" style="width: 100px;">
                    {{cell.column}}
                  </div>
                }
              </div>
            </div>
          </ng-template>
          @for (cell of row.columns; track cell; let colIndex = $index) {
            <td (contextmenu)="onRightClick($event, rowIndex, colIndex)" class="position-relative p-0">
              @if (isReadOnly == false) {
                <input [(ngModel)]="cell.column" (focus)="onEnterInput(rowIndex, colIndex)" class="form-control-sm hover-border w-100" (change)="updateTableJson()" placeholder="type here, right-click for menu" #inputRef [attr.data-index]="rowIndex+'.'+colIndex">
              }
              @if (isReadOnly == true) {
                <span>{{cell.column}}</span>
              }
              <!-- popup menu -->
              @if (rowIndex == clickedRow && colIndex == clickedColumn && showPopupMenu == true && isReadOnly == false) {
                <div class="popup-menu">
                  <a (click)="closePopupMenu()" type="button" class="btn btn-outline-secondary btn-sm noborder corner-position mx-1 my-0" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">
                    <i class="bi bi-x"></i>
                  </a>
                  <ul class="list-unstyled me-4 my-0">
                    <li class="my-0">
                      <a (click)="addRow(rowIndex, false)" type="button" class="btn btn-outline-secondary btn-sm noborder mx-1 my-0" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">
                        Insert above
                      </a>
                    </li>
                    <li class="my-0">
                      <a (click)="addRow(rowIndex, true)" type="button" class="btn btn-outline-secondary btn-sm noborder mx-1 my-0" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">
                        Insert below
                      </a>
                    </li>
                    <li class="my-0">
                      <a (click)="addColumn(colIndex, true)" type="button" class="btn btn-outline-secondary btn-sm noborder mx-1 my-0" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">
                        Insert left
                      </a>
                    </li>
                    <li class="my-0">
                      <a (click)="addColumn(colIndex, false)" type="button" class="btn btn-outline-secondary btn-sm noborder mx-1 my-0" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">
                        Insert right
                      </a>
                    </li>
                    <li class="my-0">
                      <a (click)="deleteRow(rowIndex)" type="button" class="btn btn-outline-secondary btn-sm noborder mx-1 my-0" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">
                        Delete row
                      </a>
                    </li>
                    <li class="my-0">
                      <a (click)="deleteColumn(colIndex)" type="button" class="btn btn-outline-secondary btn-sm noborder mx-1 my-0" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">
                        Delete column
                      </a>
                    </li>
                  </ul>
                </div>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>

</div>
